import { aboutData } from '@/mocks/home';

export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">{aboutData.title}</h2>
            <p className="text-base text-foreground-700 leading-relaxed mb-6">{aboutData.description}</p>
            <ul className="space-y-3">
              {aboutData.highlights.map((item, idx) => (
                <li key={idx} className="flex items-start gap-3 text-sm text-foreground-700">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mt-0.5 shrink-0">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="flex-1 w-full">
            <div className="grid grid-cols-3 gap-4">
              {aboutData.stats.map((stat, idx) => (
                <div
                  key={idx}
                  className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70"
                >
                  <div className="text-3xl md:text-4xl font-heading font-bold text-primary-500">{stat.value}</div>
                  <div className="text-xs text-foreground-600 mt-2">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}